import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { UseEntityStore } from "../../common/entityStore";
import { TmOrderDto, useTmPaymentConfirmation } from "./common";
import { getResource } from "../../common/localization";
import { Link } from "@mui/material";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.TmOrderCreated." + key, defaultMessage) as string;
}

export function PaymentLinkCreatedDialog(props: { order: TmOrderDto; close: () => void; useOrderStore: UseEntityStore<TmOrderDto>; }) {
    const { affidavit } = props.useOrderStore(p => ({
        affidavit: p.clientData.affidavit,
    }));
    const confirmation = useTmPaymentConfirmation(props.order.id!);
    const { paymentState, comgatePaymentState, newPaymentLink, waiting, generating, getPayment } = confirmation.useStore(p => ({
        paymentState: p.paymentState,
        comgatePaymentState: p.comgatePaymentState,
        newPaymentLink: p.newPaymentLink,
        waiting: p.waitAbort != null,
        generating: p.generateAbort != null,
        getPayment: p.getPaymentAbort != null,
    }));
    return <>
        <DialogTitle>{getText("Title")}</DialogTitle>
        <DialogContent>
            {!paymentState && <Box>{getText("OrderSaved").replaceAll("{custId}", props.order.custId!.toString()).replaceAll("{ordId}", props.order.ordId!.toString())}</Box>}
            {!paymentState && <Box>{getText("WaitingForPayment")}</Box>}
            {paymentState && <Box>{getText("OrderSavedAndPaid").replaceAll("{custId}", props.order.custId!.toString()).replaceAll("{ordId}", props.order.ordId!.toString())}</Box>}
            <Link style={{ marginTop: 5 }} target="_blank" href={newPaymentLink ?? props.order.tmPaymentLink} underline="always" rel="noreferrer">{newPaymentLink ?? props.order.tmPaymentLink}</Link>
            {!paymentState && comgatePaymentState && <Box>{getText("Paymentstate")} {":"} {comgatePaymentState}</Box>}
        </DialogContent>
        <DialogActions>
            {!paymentState && comgatePaymentState !== "PAID" && <Button onClick={() => confirmation.useStore.getState().generateNewPaymentLink()} disabled={generating}>{getText("GenerateNewPaymentLink")}</Button>}
            {!paymentState && comgatePaymentState !== "PAID" && <Button onClick={() => confirmation.useStore.getState().getPaymentStatusLink()} disabled={getPayment}>{getText("GetPaymentStatusLink")}</Button>}
            {!paymentState && <Button onClick={() => props.close()} color={affidavit ? "primary" : "warning"}>{getText("DoNotWaitForPayment")}</Button>}
            {(paymentState) && <Button onClick={() => props.close()}>{getResource("Ui.Ok")}</Button>}
        </DialogActions>
    </>;
}
